import {buildEmailLogPayload} from './errorTransport';

export const frontendLoggingTarget = {
  emailLog: 'emailLog',
  slackLog: 'slackLog',
  lokiLog: 'lokiLog',
  elasticLog: 'elasticLog',
};

export const defaultFrontendLoggingTargets = [
  frontendLoggingTarget.emailLog,
  frontendLoggingTarget.slackLog,
];

const emailLogPath = '/api/public/logError';
const slackLogPath = '/api/public/frontend-errors';
const legacyFrontendErrorsPath = '/frontend-errors';
const legacyDefaultElasticLoggingUrl = 'https://quotekandb.com' + legacyFrontendErrorsPath;

export function isLocalDevelopment() {
  return window.location.port === '9007'
    || window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1';
}

function getFrontendLoggingTargets() {
  if (document.kvConfig && Array.isArray(document.kvConfig.frontendLoggingTargets)
    && document.kvConfig.frontendLoggingTargets.length) {
    return document.kvConfig.frontendLoggingTargets;
  }

  return defaultFrontendLoggingTargets;
}

function getEmailLogEndpointConfig() {
  return {
    url: document.kvConfig.frontendEmailLogUrl || emailLogPath,
    formatPayload: buildEmailLogPayload,
  };
}

function getSlackLogEndpointConfig() {
  return {
    url: slackLogPath,
    transportOptions: {
      credentials: 'omit',
      useBeacon: false,
    },
  };
}

// Legacy collector retained as an opt-in fallback. It is never selected by default.
function getLegacyLokiLogEndpointConfig() {
  if (!document.kvConfig.frontendLoggingUrl) {
    return null;
  }

  return {
    url: document.kvConfig.frontendLoggingUrl,
  };
}

// Legacy collector retained as an opt-in fallback. New reports should use slackLog.
function getLegacyElasticLogEndpointConfig() {
  return {
    url: document.kvConfig.frontendElasticLoggingUrl || legacyDefaultElasticLoggingUrl,
  };
}

const endpointConfigGetters = {
  [frontendLoggingTarget.emailLog]: getEmailLogEndpointConfig,
  [frontendLoggingTarget.slackLog]: getSlackLogEndpointConfig,
  [frontendLoggingTarget.lokiLog]: getLegacyLokiLogEndpointConfig,
  [frontendLoggingTarget.elasticLog]: getLegacyElasticLogEndpointConfig,
};

export function getFrontendLoggingEndpointConfigs() {
  if (isLocalDevelopment()) {
    return [];
  }

  return getFrontendLoggingTargets()
    .filter((target, index, targets) => targets.indexOf(target) === index)
    .map((target) => endpointConfigGetters[target] && endpointConfigGetters[target]())
    .filter(Boolean);
}
